export const getOfferSignaturitEmail = (oferta) => {
    if (!oferta) return "";

    const candidates = [
        oferta.cliente_email,
        oferta.cliente_email_1,
        oferta.titular_email,
        oferta.partner_email,
        oferta.pagador_email,
    ];

    for (const candidate of candidates) {
        if (typeof candidate === "string" && candidate.trim()) {
            return candidate.trim();
        }
    }

    return "";
};